import * as React from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import ProjectListContainer from '../projects/ProjectList.container';

export interface Props {
  listKey: string;
}

class InvestComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <h1 className="bold-title">
                Invertir
              </h1>
              <div className="gap-20"/>
            </div>
            <div className="col-md-4">
              <p className="breadcrumb text-right">
                Inicio > Invertir
              </p>
            </div>
          </div>
          <ProjectListContainer
            status="open"
            listKey={this.props.listKey}
            isSimple={false}
          />
        </div>
      </section>
    );
  }
}

export default InvestComponent;


// WEBPACK FOOTER //
// ./src/modules/invest/Invest.component.tsx